import _asyncToGenerator from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { isArray } from 'lodash';
import qs from 'qs';
import { api } from '.';
import { formatCurrency, getCurrencySymbol } from '../shared/formatters';
import { multiplyNumber } from '../utils/decimal';
import { handleRequestError } from '../utils/request';
import { formatCommonDateAndTimeStr } from '../utils/time';
export var apiGetTaxRateList = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return api.get("/country?".concat(qs.stringify(payload)));

          case 3:
            res = _context.sent;

            if (isArray(res.data.data)) {
              formatCurrency;
              res.data.data.forEach(function (item) {
                var _item$currencies$;

                item.currencyText = getCurrencySymbol((_item$currencies$ = item.currencies[0]) === null || _item$currencies$ === void 0 ? void 0 : _item$currencies$.code);
                item.businessTaxRate = multiplyNumber(item.tax_rate, 100);
                item.businessTaxRateText = "".concat(item.businessTaxRate, "%");
                item.businessFixedValue = item.tax_fixed_amount;
                item.goodsInTransiteTaxRate = multiplyNumber(item.git_tax_rate, 100);
                item.goodsInTransiteTaxRateText = "".concat(item.goodsInTransiteTaxRate, "%");
                item.goodsInTransiteFixedValue = item.git_tax_fixed_amount;
                item.updatedAtText = formatCommonDateAndTimeStr(item.updated_at);
              });
            }

            return _context.abrupt("return", [res.data]);

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", handleRequestError(_context.t0, payload));

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));

  return function apiGetTaxRateList(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var apiUpdateTaxRate = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return api.patch("/country/".concat(payload.country_id), payload);

          case 3:
            res = _context2.sent;
            return _context2.abrupt("return", [res.data]);

          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", handleRequestError(_context2.t0, payload));

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 7]]);
  }));

  return function apiUpdateTaxRate(_x2) {
    return _ref2.apply(this, arguments);
  };
}();